import React, { useState } from "react"
import { ReactComponent as NotOpenIcon } from "../../images/plus-icon.svg"
import { ReactComponent as OpenIcon } from "../../images/minus-icon.svg"

const CommonTechnologies = ({ data, isWithoutFeature = false }) => {
  const [selectedItems, setSelectedItems] = useState(new Set())
  const handleToggle = value => {
    setSelectedItems(prev => {
      if (prev.has(value)) {
        prev.delete(value)
        return new Set(prev)
      }
      prev.add(value)
      return new Set(prev)
    })
  }

  return (
    <section
      id="technologies"
      className=" grid  items-center gap-[3rem] md:gap-[5.5rem]  grid-cols-1 px-6 md:px-20 py-16 md:py-[6.75rem] "
    >
      <div
        className={`flex justify-end z-[2] md:max-w-[50%]  flex-col-reverse md:flex-col  gap-6 items-start `}
      >
        <div className="flex flex-col gap-6 w-full">
          <div className="flex items-center gap-2">
            <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
            <div className="flex gap-3 tracking-tight-4% ">
              <h4 className={`text-gray-500  text-lg lg:text-2xl `}>
                {data.section}
              </h4>
            </div>
          </div>
          <h2
            className={`text-gray-100 text-[3.7rem] md:text-7xl  lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7% `}
          >
            {data.label}
          </h2>
        </div>
      </div>
      <div
        className={`flex  ${isWithoutFeature ? "flex-row flex-wrap " : "flex-col"} gap-[1.3rem]  md:gap-4`}
      >
        {data.technologies.map((tech, index) => (
          <div
            className={`${isWithoutFeature ? "  basis-full sm:basis-[calc(33.33%-0.75rem)] xl:basis-[calc(25%-0.75rem)] " : ""} p-5 md:p-6 tex-black-300  bg-white-200 flex flex-col md:flex-row rounded-[14px] gap-[1.3rem] md:gap-4`}
            key={index}
          >
            <div
              className={`flex basis-full relative  ${isWithoutFeature ? "" : "md:basis-3/12"}  items-center gap-4`}
            >
              <div className=" p-4 bg-white-100 rounded-[50%] flex-shrink-0  flex items-center justify-center ">
                <img
                  src={tech.icon}
                  alt={tech.label}
                  className="h-[14px]   md:h-[24px] w-[14px] md:w-[24px] object-contain"
                  loading="lazy"
                />
              </div>
              <div className="me-5">
                <span className="text-black-300 text-center text-[1.25rem]  lg:text-2xl -tracking-[0.32px] lg:tracking-tight-4%">
                  {tech.label}
                </span>
              </div>
              {!isWithoutFeature && (
                <span
                  onClick={() => handleToggle(tech.label)}
                  className="flex-shrink-0 flex md:hidden  absolute end-0"
                >
                  {selectedItems.has(tech.label) ? (
                    <OpenIcon />
                  ) : (
                    <NotOpenIcon />
                  )}
                </span>
              )}
            </div>
            {!isWithoutFeature && !!tech.features.length && (
              <div className="flex-grow hidden md:flex basis-full md:basis-8/12 w-full md:w-auto   flex-wrap gap-2 items-center">
                {tech.features.map((feature, index) => (
                  <div
                    key={index}
                    className={`px-3  text-secondary-100 border-gray-300 py-1 whitespace-normal tracking-tight border rounded-full text-[0.875rem] `}
                  >
                    {feature}
                  </div>
                ))}
              </div>
            )}
            {selectedItems.has(tech.label) &&
              !isWithoutFeature &&
              !!tech.features.length && (
                <div className="flex md:hidden basis-full md:basis-8/12 w-full md:w-auto   flex-wrap gap-2 items-center">
                  {tech.features.map((feature, index) => (
                    <div
                      key={index}
                      className={`px-3  text-secondary-100 border-gray-300 py-1 whitespace-normal tracking-tight border rounded-full text-[0.875rem] `}
                    >
                      {feature}
                    </div>
                  ))}
                </div>
              )}
          </div>
        ))}
      </div>
    </section>
  )
}

export default CommonTechnologies
